export default "__VITE_ASSET__Bi_mEN38__"